import { Directive, ElementRef, HostBinding, Renderer2 } from '@angular/core';
import { RangeSliderElementDirective } from '@df/ui/form/range-slider/range-slider-element.directive';

@Directive({
    selector: '[rangeSliderHandle]',
    standalone: false
})
export class RangeSliderHandleDirective extends RangeSliderElementDirective {
    @HostBinding('class.range-slider-active')
    active: boolean = false;

    @HostBinding('attr.role')
    role: string = '';

    @HostBinding('attr.tabindex')
    tabindex: string = '';

    @HostBinding('attr.aria-orientation')
    ariaOrientation: string = '';

    @HostBinding('attr.aria-label')
    ariaLabel: string = '';

    @HostBinding('attr.aria-labelledby')
    ariaLabelledBy: string = '';

    @HostBinding('attr.aria-valuenow')
    ariaValueNow: string = '';

    @HostBinding('attr.aria-valuetext')
    ariaValueText: string = '';

    @HostBinding('attr.aria-valuemin')
    ariaValueMin: string = '';

    @HostBinding('attr.aria-valuemax')
    ariaValueMax: string = '';

    focus(): void {
        this.elemRef.nativeElement.focus();
    }

    constructor(elemRef: ElementRef, renderer: Renderer2) {
        super(elemRef, renderer);
    }
}
